import CountryFieldComponent, {
  CountryFieldProps,
} from 'components/forms/fields/country-field/country-field.component';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMapsAddress } from '../../address-form.hooks';

export type CountryFieldProps2 = {
  name: string;
  'data-testid'?: string;
} & CountryFieldProps;

const CountryField = ({
  name,
  'data-testid': dataTestId = 'CountryField',
  ...rest
}: CountryFieldProps2) => {
  const { t } = useTranslation();
  useMapsAddress(name, 'country');

  return (
    <CountryFieldComponent
      name={name}
      label={t('forms.fields.country.label')}
      data-testid={dataTestId}
      {...rest}
    />
  );
};
export default React.memo(CountryField);
